export default "__VITE_ASSET__BcLhE6Ke__"